import { Box } from '@mui/material';
import { useStyles } from './InteractiveTreatmentPlan.styles';
import { Input, inputSize, inputType } from '../../../../atoms/input';

/**
 * Step 1 of Interactive Treatment Plan Flow
 * Displays and allows editing of the presenting problem
 */
const InteractiveProblemStep = ({
  problem,
  onProblemChange,
  onViewReasoning,
}) => {
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column" gap="24px">
      {/* Problem Section */}
      <Box className={classes.container}>
          <Box className={classes.sectionHeader}>
            <Box className={classes.sectionTitle}>Presenting Problem</Box>
            {problem?.rationale && (
              <Box
                className={classes.viewReasoningLink}
                onClick={onViewReasoning}
              >
                View the reasoning
              </Box>
            )}
          </Box>
          <Box className={classes.problemTextArea}>
            <Input
              multiline
              fullWidth
              rows={6}
              value={problem?.detail || ''}
              onChange={(e) => onProblemChange(e.target.value)}
              placeholder="Enter the presenting problem..."
              variant={inputType.DEFAULT}
              size={inputSize.M}
            />
          </Box>
        </Box>
      </Box>
  );
};

export { InteractiveProblemStep };

